import * as S from './SuccessModal.styled';
import { ISuccessModalProps } from './ISuccessModal';

export const SuccessModal = (props: ISuccessModalProps): JSX.Element => {
  const { icon, heading, message, operationType } = props;
  return (
    <S.SuccessModalWrapper>
      <S.ModalHeader>
        <S.SuccessModalIconWrapper className={operationType ? operationType : 'success'}>
          {icon}
        </S.SuccessModalIconWrapper>
      </S.ModalHeader>
      <S.ModalBody>
        <S.SuccessModalHeading>{heading}</S.SuccessModalHeading>
        <S.SuccessModalMessage>{message}</S.SuccessModalMessage>
      </S.ModalBody>
    </S.SuccessModalWrapper>
  );
};
